module.exports = {"classes":["tos-page","header-dark"],"title":"Terms of Service","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/terms/metadata.json
// module id = 1678
// module chunks = 0